import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import Theme from 'components/common/Theme/Theme'
import Button from 'components/common/Button/Button'
import Media from 'components/common/Media'
import TireSizeTooltip from '../../../VehicleConfigurator/components/TireSizeTooltip'
import CurrentTireSize from '../CurrentTireSize'

const ShopBySize = ({
  findMyTiresHandler,
  hasActiveVehicle,
  isTrailer,
  isTrailerTiresPage,
  hasActiveVehicleWithTireSize,
  ...props
}) =>
  <>
    <Description>
      Find tires that match my tire’s sidewall
      WIDTH, RATIO, & DIAMETER
    </Description>
    { hasActiveVehicle
      && !isTrailer
      && !isTrailerTiresPage
      && hasActiveVehicleWithTireSize
      && <CurrentTireSize { ...props } />}
    <FindTires
      data-at-find-my-tires-button
      important
      followarrow
      onClick={ findMyTiresHandler }>
      Find My Tires
    </FindTires>
    <CustomTireSizeTooltip centered small title="Where can I find my tire size?" />
  </>

export default ShopBySize

ShopBySize.propTypes = {
  findMyTiresHandler: PropTypes.func,
  hasActiveVehicle: PropTypes.bool,
  hasActiveVehicleWithTireSize: PropTypes.bool,
  isTrailer: PropTypes.bool,
  isTrailerTiresPage: PropTypes.bool
}

const Description = styled.div`
  ${Mixin.font.GothamBook(16)};
  color: ${Theme.colors.black_new};
  margin-bottom: 20px;
`

const FindTires = styled(Button)`
  cursor: pointer;
  font-size: 20px;
  padding: 10px 30px 11px;
  width: 358px;
  ${Media.mobile`
    display: block;
    margin: 0 auto;
  `}

  @media (max-width: 400px) {
    width: 100%;
    font-size: 16px;
  }
`

const CustomTireSizeTooltip = styled(TireSizeTooltip)`
  display: block;
  text-align: center;
  position: relative;
  margin: 30px auto 0;

  & [data-at-popover-inner-content] {
    bottom: 25px;
    left: -87px;
    width: 370px;
  }
`
